import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import * as Tooltip from '@radix-ui/react-tooltip';
import { ExamCompassContext } from '../Context/context';

import { FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FaSquareInstagram } from 'react-icons/fa6';
import { FaLinkedinIn } from 'react-icons/fa';
import { FaFacebookSquare } from 'react-icons/fa';

// svg
import logo from '../Assets/compass-logo.svg';

type SocialsType = {
  link: string | undefined;
  icon: React.ReactNode;
};

type CurrentPageType = {
  setCurrentPage: React.Dispatch<React.SetStateAction<string>>;
};

const Footer: React.FC<CurrentPageType> = ({ setCurrentPage }) => {
  const { about } = useContext(ExamCompassContext);

  // orange: #ffc300 pink: #ffc300
  const socials: SocialsType[] = [
    {
      link: about?.facebook,
      icon: <FaFacebookSquare size={20} style={{ color: '#023628' }} />,
    },
    {
      link: about?.instagram,
      icon: <FaSquareInstagram size={20} style={{ color: '#023628' }} />,
    },
    {
      link: about?.linkedin,
      icon: <FaLinkedinIn size={20} style={{ color: '#023628' }} />,
    },
    {
      link: about?.twitter,
      icon: <FaXTwitter size={20} style={{ color: '#023628' }} />,
    },
    {
      link: about?.youtube,
      icon: <FaYoutube size={20} style={{ color: '#023628' }} />,
    },
  ];
  return (
    <section className='pt-7 pb-7'>
      <div className='container'>
        <div className='lg:w-[1040px] mx-auto md:flex mb-8'>
          <div className='mb-8 md:mr-40 lg:mr-96'>
            <img
              className='w-[120px] md:w-[157px] mb-8 md:mb-20'
              src={logo}
              alt='ExamCompass logo'
            />
            <div className='flex flex-col gap-4 md:gap-10'>
              <HashLink
                className='text-textColor cursor-pointer hover:text-lemonGreen'
                to={'/about#'}
              >
                What We Do
              </HashLink>
              <HashLink
                className='text-textColor cursor-pointer hover:text-lemonGreen'
                to={'/about#about'}
              >
                Who We Are
              </HashLink>
              <Link
                className='text-textColor cursor-pointer hover:text-lemonGreen'
                to={'/'}
                onClick={() => setCurrentPage('home')}
              >
                Home
              </Link>
              <HashLink
                className='text-textColor cursor-pointer hover:text-lemonGreen'
                to={'/#subscribe'}
                onClick={() => setCurrentPage('subscribe')}
              >
                Subscribe
              </HashLink>
              {/*<Link
                className='text-textColor cursor-pointer hover:text-lemonGreen'
                to={'/terms-and-conditions'}
                onClick={() => setCurrentPage('terms')}
              >
                Terms And Conditions
              </Link>*/}
              <a
                href={`mailto:${about?.email || 'support@examcompassng.com'}`}
                className='text-textColor cursor-pointer hover:text-lemonGreen'
              >
                Contact Us
              </a>
              {/*<Link
                className='text-textColor cursor-pointer hover:text-lemonGreen'
                to={'/about'}
              >
                About Us
              </Link>*/}
              <a
                href="https://web.examcompassng.com/tnc/"
                className='text-textColor cursor-pointer hover:text-lemonGreen'
              >
                Terms And Conditions
              </a>
              <a
                href="https://web.examcompassng.com/privacy/"
                className='text-textColor cursor-pointer hover:text-lemonGreen'
              >
                Privacy
              </a>
            </div>
          </div>

          <div>
            <p className='text-textColor mb-8 md:gap-10'>Lagos, Nigeria</p>
            <p className='text-textColor mb-8 md:gap-10'>{about?.phone}</p>
            <a href={`mailto:${about?.email}`} className='text-textColor'>
              {about?.email}
            </a>
            <div className='flex gap-10 mt-16'>
              <Tooltip.Provider>
                {socials?.map((social, i) => (
                  <a
                    key={i}
                    href={social.link}
                    rel='noreferrer'
                    target='_blank'
                    className='cursor-pointer'
                  >
                    {social?.icon}
                  </a>
                ))}
              </Tooltip.Provider>
            </div>
          </div>
        </div>
        <p className='text-textColor text-center text-[14px]'>
          Copyright. Examcompass. All Rights Reserved
        </p>
      </div>
    </section>
  );
};

export default Footer;
